/* ══════════════════════════════════════════════════════════════
   ED FACELIFT 2026 – gemeinsames Script
   Wird im Header geladen (defer), läuft nur dort, wo data-edf-* steht.
   1. Einblenden beim Scrollen + weiches Bild-Einblenden
   2. Autoplay-Helfer (pausiert bei Hover, Fokus, außer Sicht, Tab versteckt)
   3. Zitate-Fader            [data-edf-quotes]
   4. Scroll-Slider + Pfeile  [data-edf-scroller]
   5. Akkordeon               [data-edf-accordion]
   6. Essenz-Karussell        [data-edf-essence]
   7. Code kopieren           [data-edf-copy]
   8. Header-Zustände         #SiteHeader (nur Klassen, keine Sticky-Logik)
   ══════════════════════════════════════════════════════════════ */
(function () {
  if (window.EDF) return;

  var docEl = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hasIO = 'IntersectionObserver' in window;
  if (hasIO && !reduceMQ.matches && !designMode) docEl.classList.add('edf-motion');

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function once(el, key) { if (el['__edf' + key]) return false; el['__edf' + key] = true; return true; }

  /* ── 1. Einblenden ─────────────────────────────────────────── */
  var revealIO = null;
  function initReveal(root) {
    if (!docEl.classList.contains('edf-motion')) return;
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    }
    each(root.querySelectorAll('[data-edf-reveal-group]'), function (g) {
      each(g.querySelectorAll('[data-edf-reveal]'), function (el, i) {
        el.style.setProperty('--edf-delay', Math.min(i, 4) * 70 + 'ms');
      });
    });
    each(root.querySelectorAll('[data-edf-reveal]'), function (el) {
      if (once(el, 'rv')) revealIO.observe(el);
    });
    each(root.querySelectorAll('img[data-edf-fade]'), function (img) {
      if (!once(img, 'fd')) return;
      if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
      else {
        img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
      }
    });
  }

  /* ── 2. Autoplay ───────────────────────────────────────────── */
  function autoplay(root, step, interval) {
    var timer = null, hovering = false, focused = false, inView = !hasIO;
    function run() { return !reduceMQ.matches && !designMode && !hovering && !focused && inView && !document.hidden; }
    function sync() {
      if (run() && !timer) timer = setInterval(step, interval);
      else if (!run() && timer) { clearInterval(timer); timer = null; }
    }
    root.addEventListener('mouseenter', function () { hovering = true; sync(); });
    root.addEventListener('mouseleave', function () { hovering = false; sync(); });
    root.addEventListener('focusin', function () { focused = true; sync(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focused = false; sync(); } });
    document.addEventListener('visibilitychange', sync);
    if (hasIO) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; sync(); }, { threshold: 0.3 }).observe(root);
    sync();
    return { restart: function () { if (timer) { clearInterval(timer); timer = null; } sync(); } };
  }

  /* ── 3. Zitate ─────────────────────────────────────────────── */
  function initQuotes(el) {
    if (!once(el, 'q')) return;
    var slides = el.querySelectorAll('[data-edf-slide]');
    var dots = el.querySelectorAll('.edf-dot');
    if (slides.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      each(slides, function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', String(k !== i)); });
      each(dots, function (d, k) { d.setAttribute('aria-current', String(k === i)); });
    }
    var ap = autoplay(el, function () { show(i + 1); }, parseInt(el.getAttribute('data-interval') || '7000', 10));
    each(dots, function (d, k) { d.addEventListener('click', function () { show(k); ap.restart(); }); });
    el.addEventListener('shopify:block:select', function (e) {
      var idx = Array.prototype.indexOf.call(slides, e.target);
      if (idx > -1) show(idx);
    });
    show(0);
  }

  /* ── 4. Scroll-Slider (Produkte, UGC mobil) ────────────────── */
  function initScroller(el) {
    if (!once(el, 'sc')) return;
    var track = el.querySelector('[data-edf-track]');
    if (!track) return;
    var prev = el.querySelector('[data-edf-prev]');
    var next = el.querySelector('[data-edf-next]');
    var dotsWrap = el.querySelector('[data-edf-dots]');
    function step() {
      var item = track.firstElementChild;
      if (!item) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function atEnd() { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 4; }
    function buildDots() {
      if (!dotsWrap || !track.firstElementChild) return;
      var perView = Math.max(1, Math.round(track.clientWidth / track.firstElementChild.getBoundingClientRect().width));
      var pages = Math.max(1, track.children.length - perView + 1);
      if (dotsWrap.children.length === pages) return;
      dotsWrap.innerHTML = '';
      for (var n = 0; n < pages; n++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'edf-dot'; b.setAttribute('aria-label', (dotsWrap.getAttribute('data-label') || 'Seite') + ' ' + (n + 1));
        (function (k) { b.addEventListener('click', function () { track.scrollTo({ left: k * step() }); }); })(n);
        dotsWrap.appendChild(b);
      }
      dotsWrap.hidden = pages < 2;
    }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = atEnd();
      if (dotsWrap) {
        var s = step(), active = s ? Math.round(track.scrollLeft / s) : 0;
        each(dotsWrap.children, function (d, k) { d.setAttribute('aria-current', String(k === active)); });
      }
    }
    function placeArrows() {
      var ref = el.querySelector('[data-edf-arrow-ref]');
      if (!ref) return;
      var top = ref.getBoundingClientRect().top - el.getBoundingClientRect().top + ref.offsetHeight / 2;
      el.style.setProperty('--edf-arrow-top', top + 'px');
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); update(); placeArrows(); });
    each(el.querySelectorAll('[data-edf-arrow-ref] img'), function (img) { img.addEventListener('load', placeArrows); });
    el.addEventListener('shopify:block:select', function (e) {
      var item = e.target.closest ? e.target.closest('[data-edf-track] > *') : null;
      if (item) track.scrollTo({ left: item.offsetLeft - track.offsetLeft });
    });
    buildDots(); update(); placeArrows();

    if (el.hasAttribute('data-edf-autoplay')) {
      autoplay(el, function () { if (!atEnd()) track.scrollBy({ left: step() }); }, parseInt(el.getAttribute('data-edf-autoplay'), 10) || 6000);
    }
  }

  /* ── 5. Akkordeon (immer nur ein Eintrag offen) ────────────── */
  function initAccordion(el) {
    if (!once(el, 'ac')) return;
    var items = el.querySelectorAll('[data-edf-acc-item]');
    each(items, function (item) {
      var btn = item.querySelector('[data-edf-acc-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        each(items, function (other) {
          var open = other === item && willOpen;
          other.classList.toggle('is-open', open);
          var b = other.querySelector('[data-edf-acc-btn]');
          if (b) b.setAttribute('aria-expanded', String(open));
        });
      });
    });
    /* Desktop: Höhe für den längsten Eintrag reservieren -> kein Springen */
    var wide = window.matchMedia('(min-width: 1024px)');
    function reserve() {
      if (!wide.matches) { el.style.minHeight = ''; return; }
      var base = 0, tallest = 0;
      each(items, function (item) {
        var b = item.querySelector('[data-edf-acc-btn]');
        var inner = item.querySelector('[data-edf-acc-inner]');
        base += (b ? b.offsetHeight : 0) + 1;
        if (inner) tallest = Math.max(tallest, inner.scrollHeight);
      });
      el.style.minHeight = (base + tallest + 1) + 'px';
    }
    reserve();
    window.addEventListener('resize', reserve);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reserve);
    each(el.querySelectorAll('img'), function (img) { img.addEventListener('load', reserve); });
  }

  /* ── 6. Essenz-Karussell ─────────────────────────────────── */
  function initEssence(el) {
    if (!once(el, 'es')) return;
    var slides = el.querySelectorAll('[data-edf-es-slide]');
    var images = el.querySelectorAll('[data-edf-es-image]');
    var dots = el.querySelectorAll('[data-edf-es-dot]');
    if (!slides.length) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      [slides, images].forEach(function (list) {
        each(list, function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', String(k !== i)); });
      });
      each(dots, function (d) { d.setAttribute('aria-current', String(parseInt(d.getAttribute('data-edf-es-dot'), 10) === i)); });
    }
    each(el.querySelectorAll('[data-edf-es-prev]'), function (b) { b.addEventListener('click', function () { show(i - 1); }); });
    each(el.querySelectorAll('[data-edf-es-next]'), function (b) { b.addEventListener('click', function () { show(i + 1); }); });
    each(dots, function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-edf-es-dot'), 10)); }); });
    /* Wischen auf dem Bild (mobil) */
    var media = el.querySelector('[data-edf-es-media]');
    if (media) {
      var x0 = null;
      media.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) show(i + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    el.addEventListener('shopify:block:select', function (e) {
      var idx = Array.prototype.indexOf.call(slides, e.target);
      if (idx > -1) show(idx);
    });
    show(0);
  }

  /* ── 7. Code kopieren ────────────────────────────────────── */
  function initCopy(btn) {
    if (!once(btn, 'cp')) return;
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-edf-copy');
      var label = btn.querySelector('[data-edf-copy-label]');
      var status = btn.parentElement.querySelector('[data-edf-copy-status]');
      function done() {
        btn.classList.add('is-copied');
        if (label) label.textContent = btn.getAttribute('data-copied-text') || 'Kopiert';
        if (status) status.textContent = 'Code ' + code + ' kopiert';
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (label) label.textContent = code;
          if (status) status.textContent = '';
        }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
    });
  }

  /* ── 8. Header: Schatten ab Scroll (Sticky-Logik bleibt beim Theme) ── */
  function initHeader() {
    var header = document.getElementById('SiteHeader');
    if (!header || !once(header, 'hd')) return;
    var ticking = false;
    function onScroll() {
      header.classList.toggle('edf-is-scrolled', window.scrollY > 40);
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    each(root.querySelectorAll('[data-edf-quotes]'), initQuotes);
    each(root.querySelectorAll('[data-edf-scroller]'), initScroller);
    each(root.querySelectorAll('[data-edf-accordion]'), initAccordion);
    each(root.querySelectorAll('[data-edf-essence]'), initEssence);
    each(root.querySelectorAll('[data-edf-copy]'), initCopy);
    initHeader();
  }

  window.EDF = { init: init, autoplay: autoplay };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
